import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { statisticsColors } from './../../settings/settings';

const Statistic = props => {
  const [percentage, setPercentage] = useState(-1);
  
  useEffect(() => {
    setPercentage(props.percentage > 0 ? parseFloat(props.percentage.toFixed(2)) : props.percentage);
  }, [props.percentage]);

  function getColor() {
    if (percentage >= 0 && percentage < 26) {
      return statisticsColors.green;
    } else if (percentage >= 26 && percentage < 51) {
      return statisticsColors.yellow;
    } else if (percentage >= 51 && percentage < 76) {
      return statisticsColors.orange;
    } else if (percentage >= 76) {
      return statisticsColors.red;
    }
    return 'transparent';
  }
  return (
    <div className="Status">
      <span style={{ backgroundColor: getColor() }} />
    </div>
  );
};

Statistic.propTypes = {
  percentage: PropTypes.number
};

Statistic.defaultProps = {
  percentage: -1
};

export default Statistic;
